import { SimpleGrid, SimpleGridProps, BoxProps } from "@chakra-ui/react";
import EmptyState from "components/EmptyState";
import Panel from "components/Panel";

import TinyHeading from "components/TinyHeading";
import { TraitTileProps } from "components/TraitTile";

type TraitsListProps = Omit<BoxProps, "gap" | "children"> &
  Pick<SimpleGridProps, "gap" | "columns"> & {
    title: string;
    children?: (React.ReactElement<TraitTileProps> | null)[];
  };

const TraitsList = ({
  title,
  children,
  columns = 1,
  gap = "2px",
  ...rest
}: TraitsListProps) => (
  <Panel {...rest}>
    <TinyHeading mb="3">{title}</TinyHeading>

    {children?.length ? (
      <SimpleGrid gap={gap} columns={columns}>
        {children}
      </SimpleGrid>
    ) : (
      <EmptyState pt="6" pb="6" opacity="0.4" />
    )}
  </Panel>
);

export default TraitsList;
